import axios from 'axios';

/**
 * Liste des actions
 */
export const Actions = {
    FETCH_TYPES_REQUEST: 'FETCH_TYPES_REQUEST',
    FETCH_TYPES_SUCCESS: 'FETCH_TYPES_SUCCESS',
    FETCH_TYPES_FAILURE: 'FETCH_TYPES_FAILURE'
};

/**
 * FETCH_TYPES
 * ActionCreator pour la récupération des types
 */
const fetchTypesRequest = () => ({ type: Actions.FETCH_TYPES_REQUEST });
const fetchTypesSuccess = types => ({ type: Actions.FETCH_TYPES_SUCCESS, types });
const fetchTypesFailure = error => ({ type: Actions.FETCH_TYPES_FAILURE, error });

export const fetchTypes = () => (dispatch, getState) => {

    if (getState().type.types.isLoading) {
        return;
    }
    if (getState().type.types.items.length > 0) {
        return;
    }
    return dispatch(_fetchTypes());
};

export const _fetchTypes = () => async (dispatch) => {

    dispatch(fetchTypesRequest());

    try {
        let response = await axios.get('api/types');
        dispatch(fetchTypesSuccess(response.data));
    } catch (error) {
        console.error('fetchTypes : ', error);
        dispatch(fetchTypesFailure(error));
    }
};